import Links from './Links';
import LinkWithTooltip from './LinkWithTooltip';

export type { ILinkConfig } from './Links';
export { LinkWithTooltip, Links };

export default Links;
